import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { RuleSmsTemplateApprovedWithoutAutosendActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function RuleSmsTemplateApprovedWithoutAutosend({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as RuleSmsTemplateApprovedWithoutAutosendActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信审核已通过，当前状态为暂停发送</ItemWrapper>
}
